/**
 * Section navigation interactions
 * 
 * @package crunchy
 */

(function($) {
	$(document).ready(function() {

		// sanity check
		if ( ! $( 'body' ).hasClass( 'section-page' ) ) {
			return;
		}

		// get stuff
		var navigation		= $( '#section-menus' );
		var drop			= $( '#section-drop' );
		var dropToggler		= $( '.drop-toggler', navigation );
		var dropPane		= $( '.pane', drop );
		var primary			= $( '.primary', navigation );
		var primaryToggler	= $( '.primary-toggler', navigation );

		// bindings
		primaryToggler.on( 'click', togglePrimary );
		dropToggler.on( 'click', toggleDrop );


		/**
		 * Toggle primary mobile primary menu
		 * 
		 * @since 1.0.0
		 */
		function togglePrimary() {
			primary.toggleClass( 'toggled' );

			primaryToggler.toggleClass( 'toggled' );
			$( '.ctas', navigation ).slideToggle( 400 );
		}


		/**
		 * Toggle the drop-down menu
		 * 
		 * @since 1.0.0
		 */
		function toggleDrop() {
			
			dropToggler.toggleClass( 'toggled' );
		}
	}); // document.ready
})(jQuery);